<div class="container py-4 py-md-5 text-center">
  <div [inlineSVG]="'assets/img/globeError.svg'" class="mb-5"></div>
  <h1 class="font-22 uppercase font-weight-bold">{{'pageNotFound'|translate}}</h1>
  <p class="font-17 mb-5">{{'sorryThePageyouRequestedCouldNotBeFound'|translate}}</p>
  <button class="w-initial px-5 m-auto" routerLink="/">{{'goToMainPage'|translate}}</button>
</div>
